<template>
  <section class="left-bar">
    <div></div>
    <NavBarVue/>
    <div class="clock-bar">
      <p class="time">{{ time }}</p>
      <p class="date">{{ date }}</p>
    </div>
  </section>
</template>

<script>
import NavBarVue from './NavBar.vue';
export default {
  components:{
    NavBarVue
  },
  data: () => ({
    time: "00:00",
    count: null,
    date: "",
  }),
  methods: {
    getTime() {
      setTimeout(() => {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        // var ampm = hours >= 12 ? 'pm' : 'am';
        //   hours = hours % 12;
        //   hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        // console.log("tiempo");
        this.time = hours + ":" + minutes;
      }, 1000);
    },
    getDate() {
      var d = new Date();
      var weekday = new Array(7);
      weekday[0] = "Sun";
      weekday[1] = "Mon";
      weekday[2] = "Tue";
      weekday[3] = "Wed";
      weekday[4] = "Thu";
      weekday[5] = "Fri";
      weekday[6] = "Sat";
      var nameDay = weekday[d.getDay()];
      var month = new Array();
      month[0] = "Jan";
      month[1] = "Feb";
      month[2] = "Mar";
      month[3] = "Apr";
      month[4] = "May";
      month[5] = "Jun";
      month[6] = "Jul";
      month[7] = "Aug";
      month[8] = "Sep";
      month[9] = "Oct";
      month[10] = "Nov";
      month[11] = "Dec";
      var nameMont = month[d.getMonth()];
      this.date = ` ${nameDay},${d.getDate()} ${nameMont} ${d.getFullYear()}`;
    },
  },
  mounted() {
    this.getTime();
    this.getDate();
  },
};
</script>

<style>
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
}
.left-bar {
  transition: 0.5s;
  width: 100%;
  height: 100%;
  background: var(--firts-color);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: none;
}
.left-bar .clock-bar {
  width: 100%;
  text-align: center;
}
.left-bar .clock-bar p {
  margin: 0;
}
.left-bar .clock-bar .time {
  font-family: "PT Sans", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: #fff;
}
.left-bar .clock-bar .date {
  font-family: "PT Sans", sans-serif;
  font-weight: 400;
  font-size: 0.5rem;
  color: #fff;
}
</style>